module.exports = __webpack_public_path__ + "static/assets/a1acb42fc7af14b30caa5b20fbdf63be.svg";